import { TYPE } from './recordingsBar.types';

const initialState = {
  timeUsed: null,
  totalTime: null,
  show: true,
};

export const recordingsBar = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case TYPE?.SET_DATA_TIME:
      return {
        ...state,
        timeUsed: payload?.timeUsed,
        totalTime: payload?.totalTime,
      };

    case TYPE?.SET_SHOW_CONTAINER_RECORDING_BAR:
      return {
        ...state,
        show: payload?.show,
      };

    default:
      return {
        ...state,
      };
  }
};
